import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    marginTop: theme.spacing(2),
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
  },
  divider: {
    width: '100%',
    borderBottom: `1px solid ${theme.palette.colors.divider}`,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/BidRequestInfo/useStyles.js